module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Outgoing-call-839a8f93a639f9fe806c13bb2bf9a59d.svg";